import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lims_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    if (err.response?.status === 401 && !path.startsWith("/login") && !path.startsWith("/scan")) {
      localStorage.removeItem("lims_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export function formatMoney(amount, currency = "USD") {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount ?? 0);
  } catch {
    return `${currency} ${Number(amount ?? 0).toFixed(2)}`;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const ROLE_LABELS = {
  admin: "Admin",
  quality_manager: "Quality Manager",
  technical_manager: "Technical Manager",
  supervisor: "Supervisor",
  technician: "Calibration Technician",
  customer: "Customer",
};

export const STAFF_ROLES = ["admin", "quality_manager", "technical_manager", "supervisor", "technician"];

export const QUOTATION_STATUSES = { draft: "Draft", sent: "Sent", accepted: "Accepted", rejected: "Rejected" };
export const EQUIPMENT_STATUSES = {
  received: "Received",
  in_calibration: "In Calibration",
  completed: "Completed",
  dispatched: "Dispatched",
};

export default api;
